import { getEncryptor, isNetworkError } from "../services/siteService";
import api from "../utils/api";
import { S_AUTH_TOKEN, S_LANG, webStorage } from "../utils/webStorage";
import { getToken, getUserInfo } from "../services/userService";
import { useDispatch } from "react-redux";
import { setUserInfoAction } from "../redux/actions";
import { useState } from "react";
import useQuery from "../utils/useQuery";
import { useHistory } from "react-router-dom";

const useAccountLogin = () => {
  /*Redux start*/
  const dispatch = useDispatch();
  const setUserInfo = payload => dispatch(setUserInfoAction(payload));
  /*Redux end*/
  const lang = webStorage.get(S_LANG);
  const query = useQuery();
  const history = useHistory();
  const [loginSubmitting, setLoginSubmitting] = useState(false);
  const [loginFailed, setLoginFailed] = useState(null);
  const [loginWrongEmailOrPassword, setLoginWrongEmailOrPassword] = useState(null);
  const [loginNetworkError, setLoginNetworkError] = useState(null);
  const [loginAccountLock, setLoginAccountLock] = useState(false);
  const [temporaryLock, setTemporaryLock] = useState(false);
  const login = async (email, password) => {
    if (!loginSubmitting) {
      setLoginSubmitting(true);
      setLoginFailed(false);
      setLoginNetworkError(false);
      setLoginAccountLock(false);
      setTemporaryLock(false);
      setLoginWrongEmailOrPassword(false);
      try {
        const token = await getToken(email, password, lang);
        webStorage.set(S_AUTH_TOKEN, {
          ...token,
          loginTime: new Date().getTime()
        });
        try {
          const user = await getUserInfo();
          setUserInfo(user);
          return {
            token,
            userInfo: user
          };
        } catch (ex) {
          if (ex.status && ex.status !== 200) {
            setLoginNetworkError(true);
          } else {
            if (ex.code === "USER_CUSTOMER_0003") {
              setLoginWrongEmailOrPassword(true);
            } else {
              setLoginFailed(true);
            }
          }
          return {};
        }
      } catch (ex) {
        if (ex.status && ex.status !== 200) {
          setLoginNetworkError(true);
        } else if (ex.code === "ECOMMERCE_GATEWAY_0002") {
          switch (ex.obj?.state) {
            case "LOCK":
              setLoginAccountLock(true);
              break;
            case "TEMPORARY_DISABLED":
              setTemporaryLock(true);
              break;
            default:
              setLoginWrongEmailOrPassword(true);
              break;
          }
        } else {
          setLoginFailed(true);
        }
        return {};
      } finally {
        setLoginSubmitting(false);
      }
    }
  };
  const loginRedirect = async (email, password, redirect) => {
    const { token } = await login(email, password);
    if (redirect.startsWith("https://") || redirect.startsWith("http://")) {
      global.location.href = `${redirect}?token=${token.accessToken}`;
    } else {
      history.replace(query.redirect);
    }
  };
  return {
    loginSubmitting,
    loginFailed,
    loginWrongEmailOrPassword,
    loginNetworkError,
    loginAccountLock,
    temporaryLock,
    login,
    loginRedirect
  };
};
export default useAccountLogin;
